// Pure helper answering "is the browser currently on one of the public
// (token-link) form pages?" — the pages a referee/candidate lands on from
// an emailed or texted link, with no account or login involved. Lives in
// repo-root shared so both the global HTTP interceptor and the per-project
// app components can use it.
//
// The match is anchored and requires a token segment, so protected routes
// that nest the same words deeper (/dashboard/references,
// /candidates/:id/references) never match.
const PUBLIC_FORM_PATH =
  /^\/(references|reference-requests|verification-requests|permissions|signatures|forms)\/[^/]+/;

export function isPublicFormPath(
  pathname: string = window.location.pathname
): boolean {
  return PUBLIC_FORM_PATH.test(pathname);
}

// The configuration panel's live previews of the candidate reference-request
// form and of the reference form (each opened in its own tab, see
// FormPreviewService). Rendered by the same public route family, but it is a
// recruiter looking at a sample, so third-party chrome (cookie banner, help
// launcher) stays out of the way.
const FORM_PREVIEW_PATH = /^\/(references|reference-requests)\/preview(\/|$)/;

export function isFormPreviewPath(
  pathname: string = window.location.pathname
): boolean {
  return FORM_PREVIEW_PATH.test(pathname);
}
